import React, {Component} from 'react';
import {Header, Icon} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization, parseMultilineString} from "../utils/localization";
import {CustomGrid} from "./custom-common";

const mapStateToProps = (state, ownProps) => {
    const {user} = state;
    return {
        lang: user.lang,
        ...ownProps
    }
};

class LinkExpired extends Component {
    componentDidMount() {
        window.onbeforeunload = null;
    }

    render() {
        const localization = getLocalization(this.props.lang);
        const strings = localization.linkExpired;

        return (
            <CustomGrid container stackable columns={1} centered>
                <CustomGrid.Row>
                    <CustomGrid.Column textAlign='center' width={6} style={{marginTop: '10em'}}>
                        <div>
                            <Icon style={{boxShadow: 'none'}} className={'warningIconRounded'} name={'warning sign'} circular size={'big'}/>
                        </div>
                        <Header as={'h4'} className='neutral900Text'>{strings.title}</Header>
                        <p>
                            {parseMultilineString(strings.description)}
                        </p>
                    </CustomGrid.Column>
                </CustomGrid.Row>
            </CustomGrid>
        );
    }
}

export default withRouter(connect(mapStateToProps)(LinkExpired));
